// Frans (fr-FR), golf2App: zelfde vorm als golf2App.nl.ts. Tu-vorm, kort; namen van de dingen in
// de tas zoals een kind ze kent.
export const appChecklistFr = {
    title: 'Liste',
    hint: 'Qu’est-ce qu’il faut emporter ? La tablette montre la liste à côté de l’appel et ton enfant la coche.',
    empty: 'Rien sur la liste pour l’instant. Choisis ci-dessous ou ajoute toi-même quelque chose.',
    suggestions: 'Propositions',
    suggestionAdd: 'Ajouter {label}',
    addAll: 'Tout ajouter',
    newLabel: 'Autre chose',
    newPlaceholder: 'Par exemple : Lunettes de natation',
    add: 'Ajouter',
    labelRequired: 'Écris un mot.',
    labelTooLong: '40 caractères au maximum.',
    max: '12 choses au maximum par liste.',
    itemPicto: 'Image pour {label}',
    up: 'Monter {label}',
    down: 'Descendre {label}',
    remove: 'Retirer {label}',
    previewTitle: 'À côté de l’appel',
    sheetTitle: 'Dans le sac',
    sheetProgress: '{done} sur {total} dans le sac',
    sheetAllDone: 'Tout est dans le sac',
    sheetNone: 'Rien de coché pour l’instant',
    sheetItemDone: '{label} : dans le sac',
    sheetItemOpen: '{label} : pas encore',
    items: {
        'swim-trunks': 'Maillot de bain',
        swimsuit: 'Maillot une pièce',
        towel: 'Serviette',
        underwear: 'Culotte ou slip',
        socks: 'Chaussettes',
        shampoo: 'Shampooing',
        slippers: 'Tongs',
        'football-boots': 'Chaussures de foot',
        'shin-guards': 'Protège-tibias',
        'water-bottle': 'Gourde',
        quran: 'Coran',
        backpack: 'Sac',
        headscarf: 'Foulard',
        'prayer-cap': 'Calotte de prière',
        coat: 'Manteau',
        shoes: 'Chaussures',
        lunch: 'Repas du midi',
        fruit: 'Fruit',
        homework: 'Devoirs',
        reading: 'Livre de lecture',
        'music-lesson': 'Cahier de musique',
        'get-dressed': 'Tenue de sport',
    },
};
export const appActivitiesFr = {
    section: 'Activité régulière',
    toggle: 'C’est une activité régulière',
    toggleHint: 'Comme l’école, le cours à la mosquée ou le foot : a lieu chaque semaine, sauf pendant les vacances et les pauses que tu choisis ci-dessous.',
    needsRecurrence: 'Choisis d’abord une répétition : une activité régulière revient chaque semaine.',
    followSchool: 'Suit les vacances scolaires',
    followSchoolHint: 'Pendant les vacances scolaires de la région {region}, cette activité n’a pas lieu.',
    followSchoolNoRegion: 'Choisissez votre zone de vacances scolaires dans les paramètres ci-dessous. Elle s’applique à toute la famille.',
    regions: { noord: 'Nord', midden: 'Centre', zuid: 'Sud' },
    pauses: 'Pauses',
    pausesHint: 'Périodes pendant lesquelles cette activité s’arrête. Une pause peut être partagée avec d’autres activités.',
    noPauses: 'Pas encore de pauses.',
    newPause: 'Nouvelle pause',
    pauseName: 'Nom',
    pauseNamePlaceholder: 'Pause d’été',
    pauseFrom: 'Du',
    pauseTo: 'Au',
    pauseAdd: 'Ajouter la pause',
    pauseCancel: 'Annuler',
    pauseNameRequired: 'Donne un nom à la pause.',
    pauseRangeInvalid: 'Choisis une date de fin égale ou après la date de début, dans l’année.',
    pausePresets: {
        zomerstop: 'Pause d’été',
        winterstop: 'Pause d’hiver',
        zomervakantie: 'Vacances d’été',
    },
    sharedWith: 'Aussi pour : {names}',
    saved: 'Activité régulière enregistrée',
    saveFailed: 'L’événement est enregistré, mais pas les pauses. Réessaie.',
    barLabel: '{title}, {range}',
    schoolHoliday: 'Vacances scolaires',
    pause: 'Pause',
    stops: 'En pause : {names}',
    stopsNone: 'Aucune activité régulière n’est en pause à ce moment-là.',
    sheetSchoolHint: 'Les vacances scolaires viennent du gouvernement néerlandais (Rijksoverheid), pour ta région. Une activité régulière qui les suit n’a pas lieu pendant ce temps.',
    sheetPauseHint: 'Pendant cette période, les activités ci-dessous n’ont pas lieu : pas d’appel, pas de trajet.',
    editPause: 'Modifier la pause',
    deletePause: 'Retirer la pause',
    deletePauseConfirm: 'Tu confirmes ? Les activités auront alors lieu normalement pendant cette période.',
    pauseDeleted: 'Pause « {name} » retirée',
    pauseUpdated: 'Pause « {name} » enregistrée',
    fixedChip: 'Activité régulière',
};
//# sourceMappingURL=golf2App.fr.js.map